import React, { useState, useEffect, useRef } from 'react';
import './AltStatsBar.css';

const ACCENT = '#0B5BD8';

const STATS = [
  { prefix: '',  numeric: 2000, suffix: '+',  unit: '',    label: 'Creators worldwide',   sub: 'and growing daily' },
  { prefix: '$', numeric: 2,    suffix: 'M+', unit: '',    label: 'Paid out to creators', sub: 'real money, real fast' },
  { prefix: '',  numeric: 90,   suffix: '%',  unit: '',    label: 'Revenue kept by you',  sub: 'industry-leading payout' },
  { prefix: '$', numeric: 0,    suffix: '',   unit: '',    label: 'To get started',       sub: 'no monthly fees' },
  { prefix: '',  numeric: 30,   suffix: '',   unit: 'sec', label: 'To start selling',     sub: 'five-minute full setup' },
  { prefix: '',  numeric: 14,   suffix: '+',  unit: '',    label: 'AI tools for creators', sub: 'and more coming soon' },
];

function useCountUp(target, duration, started) {
  const [val, setVal] = useState(0);
  useEffect(() => {
    if (!started || target === 0) { setVal(target); return; }
    let startTs = null;
    const step = (ts) => {
      if (!startTs) startTs = ts;
      const p = Math.min((ts - startTs) / duration, 1);
      const ease = 1 - Math.pow(1 - p, 3);
      setVal(Math.round(ease * target));
      if (p < 1) requestAnimationFrame(step);
    };
    requestAnimationFrame(step);
  }, [target, duration, started]);
  return val;
}

function useOnScreen(ref) {
  const [vis, setVis] = useState(false);
  useEffect(() => {
    const obs = new IntersectionObserver(
      ([e]) => { if (e.isIntersecting) { setVis(true); obs.disconnect(); } },
      { threshold: 0.25 }
    );
    if (ref.current) obs.observe(ref.current);
    return () => obs.disconnect();
  }, [ref]);
  return vis;
}

function StatNum({ stat, started }) {
  const val = useCountUp(stat.numeric, 1400, started);
  const display = stat.numeric >= 1000 ? val.toLocaleString() : String(val);
  return (
    <span className="asb-stat-num">
      {stat.prefix}{display}{stat.suffix}
      {stat.unit && <span className="asb-stat-unit"> {stat.unit}</span>}
    </span>
  );
}

function StatCard({ stat, vis }) {
  const [hovered, setHovered] = useState(false);
  return (
    <div
      className={`asb-card${hovered ? ' asb-card--hover' : ''}`}
      style={hovered ? { borderColor: ACCENT + '44', boxShadow: `0 20px 48px ${ACCENT}18, 0 0 0 1px ${ACCENT}22` } : {}}
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
    >
      <StatNum stat={stat} started={vis} />
      <div className="asb-card-labels">
        <span className="asb-card-label">{stat.label}</span>
        <span className="asb-card-sub">{stat.sub}</span>
      </div>
    </div>
  );
}

export default function AltStatsBar() {
  const ref = useRef(null);
  const vis = useOnScreen(ref);

  return (
    <section className="asb-section">
      <div ref={ref} className="asb-grid">
        {STATS.map((s) => <StatCard key={s.label} stat={s} vis={vis} />)}
      </div>
    </section>
  );
}
